const SEPARATOR = ' • ';
// Episode subtitles can carry a prefix ending in a non-breaking space and a hyphen.
const EPISODE_PREFIX = ' - ';

const joinLine = (parts: Array<string | undefined>): string | undefined => {
	const line = parts.filter(Boolean).join(SEPARATOR);
	return line || undefined;
};

export const humanizeType = (type?: string): string | undefined => {
	if (!type) {
		return undefined;
	}
	const spaced = type.replace(/_/g, ' ');
	return spaced.charAt(0).toUpperCase() + spaced.slice(1);
};

export const getDailyLines = ({
	contentType,
	narratorName,
	subtitle,
	description,
	promotionalText,
}: {
	contentType?: string;
	narratorName?: string;
	subtitle?: string;
	description?: string;
	promotionalText?: string;
}) => {
	const dateLine = joinLine([description, promotionalText]);
	const repeatsDateLine = (part: string) =>
		part === dateLine || part === description || part === promotionalText;
	const descriptor = joinLine(
		[contentType, narratorName, subtitle].filter(
			(part, index, all) => part && all.indexOf(part) === index && !repeatsDateLine(part),
		),
	);

	return { descriptor, dateLine };
};

export const getPlainLines = ({
	title,
	contentType,
	narratorName,
	subtitle,
}: {
	title?: string;
	contentType?: string;
	narratorName?: string;
	subtitle?: string;
}) => {
	const type = humanizeType(contentType);
	const secondary = joinLine([type, narratorName ?? subtitle]);

	let episode: string | undefined;
	if (subtitle && narratorName) {
		const prefixIndex = subtitle.indexOf(EPISODE_PREFIX);
		episode = prefixIndex === -1 ? subtitle : subtitle.slice(prefixIndex + EPISODE_PREFIX.length);
		if (!episode || [title, narratorName, type].includes(episode)) {
			episode = undefined;
		}
	}

	return { secondary, episode };
};
